// export const BASE_API_URL = 'https://tring-tring-server.onrender.com/';
export const BASE_API_URL = 'http://ec2-3-110-37-161.ap-south-1.compute.amazonaws.com:8080/';
// export const BASE_API_URL = 'http://localhost:8080/';